export const FEED_ARTICLE_ENDPOINT_BASE = 'api/v1/cms/cms_articles';
export const BRAND_VIEW_FEED_SLUG = 'cms-service-test-feed'; // temp until a special feed is created for brand viw
export const BRAND_FEED_SLUG = 'brand-feed';
export const DISCOVER_TAB_FEED_SLUG = 'search-landing-feed-web';

// --------------------------
// SEARCH CONFIG TYPES
// --------------------------
export const SEARCH_CONFIG_TYPES = {
  BRAND: 'brand',
  BROWSE: 'browse',
  CATEGORY: 'category',
  COLLECTION: 'collection',
  COLOR: 'color',
  DISCOUNT_TAG: 'discount_tag',
  SEARCH: 'search',
};

// --------------------------
// BRAND VIEW HOMEPAGE SECTION
// --------------------------

export const BRAND_VIEW_SECTION_TYPES = Object.freeze({
  HERO_SECTION: 'HeroSection',
  VIDEO_HERO_SECTION: 'VideoHeroSection',
  SPACE_ARTICLE_SECTION: 'SpaceArticleSection',
});

// --------------------------
// HOMEPAGE TAB SECTION CONTENT
// --------------------------
export const SECTION_TYPES = Object.freeze({
  BRAND_LIST_SECTION: 'BrandListSection',
  CATEGORY_LIST_SECTION: 'CategoryListSection',
  DETAILED_PRODUCT_LIST_SECTION: 'DetailedProductListSection',
  PRODUCT_CAROUSEL_ROWS_SECTION: 'ProductCarouselRowsSection',
  PRODUCT_GRID_SECTION: 'ProductGridSection',
  SPACE_ARTICLE_SECTION: 'SpaceArticleSection',
  VERTICAL_LIST_CAROUSEL_SECTION: 'VerticalListCarouselSection',
});

// --------------------------
// PRODUCT GRID SECTION
// --------------------------
export const PRODUCT_GRID_SECTION_RESULTS_PER_PAGE = 100;

// --------------------------
// PRODUCT CAROUSEL ROWS SECTION
// --------------------------
export const PRODUCT_CAROUSEL_ROWS_SECTION_RESULTS_PER_PAGE = 16;

// --------------------------
// BRAND LIST SECTION
// --------------------------
export const BRAND_SUBSECTIONS_TYPE = 'CuratedLinkSection';
export const NUM_OF_ROWS_IN_BRAND_LIST_TABLE = 7;

// --------------------------
// VERTICAL LIST CAROUSEL SECTION
// --------------------------
export const VERTICAL_LIST_CAROUSEL_RANK_LIST_SECTION = 'RankListSection';
export const VERTICAL_LIST_CAROUSEL_PRICE_LIST_SECTION = 'PriceListSection';

// --------------------------
// DETAILED PRODUCT LIST SECTION
// --------------------------
export const PRODUCT_ROWS_PER_PAGE = 4;

// --------------------------
// SPACE ARTICLE SECTION
// --------------------------
export const DEFAULT_ASSET_HEIGHT_BEFORE_UI_RENDERS = 800;
export const DEFAULT_ASSET_WIDTH_BEFORE_UI_RENDERS = 375;

// --------------------------
// SPACE VIEW TYPES
// --------------------------
export const SPACE_VIEW_TYPES = {
  MOBILE_VIEW: 'mobile_web',
  DESKTOP_VIEW: 'desktop_web',
};
